/* global gform, gforms_recaptcha_recaptcha_strings, grecaptcha */
( ( gform, grecaptcha, strings ) => {

	const initScore = () => {
		let isInitialized = false;
		document.addEventListener( 'gform/post_render', ( event ) => {
			// Abort if already initialized.
			if ( isInitialized ) {
				return;
			}
			isInitialized = true;

			// Executing on AJAX validation.
			gform.utils.addAsyncFilter( 'gform/ajax/pre_ajax_validation', async ( data ) => {
				await execute( data.form );
				return data;
			} );

			// Executing recaptcha on form submission or Next button click.
			gform.utils.addAsyncFilter( 'gform/submission/pre_submission', async ( data ) => {
				const recaptchaRequired = data.submissionType === gform.submission.SUBMISSION_TYPE_SUBMIT || data.submissionType === gform.submission.SUBMISSION_TYPE_NEXT;
				if ( recaptchaRequired && ! data.abort ) {
					await execute( data.form );
				}
				return data;
			} );
		} );

		maybeDisableBadge();
	};

	const initCheckbox = () => {
		document.addEventListener( 'gform/post_render', ( event ) => {
			renderCheckboxes( event.detail.formId );
		} );

		document.addEventListener( 'gfcf/conversational/navigate/next', ( event ) => {
			if ( ! event.detail.target.classList.contains( 'gfield--type-recaptcha_checkbox' ) ) {
				return;
			}

			const container = event.detail.target.querySelector( '.g-recaptcha' );
			renderCheckbox( container );
		} );

		gform.addAction( 'gform_post_conditional_logic_field_action', ( formId, action, targetId, defaultValues, isInit ) => {
			if ( action !== 'show' ) {
				return;
			}

			const field = gform.utils.getNode( targetId, document, true );
			if ( ! field || ! field.classList.contains( 'gfield--type-recaptcha_checkbox' ) ) {
				return
			}

			const container = field.querySelector( '.g-recaptcha' );
			renderCheckbox( container, isInit );
		} );

		gform.utils.addAsyncFilter( 'gform/ajax/post_ajax_submission', ( data ) => {
			if ( ! data.submissionResult?.data?.recaptcha_checkbox_response ) {
				return data;
			}

			const input = gform.utils.getNode( 'input.gfield_recaptcha_response', data.form, true );
			if ( input ) {
				input.value = data.submissionResult.data.recaptcha_checkbox_response;
			}

			return data;
		} );
	}

	/**
	 * @function execute
	 * @description Execute standard or enterprise reCAPTCHA depending on the connection type.
	 *
	 * @since 2.2.0
	 *
	 * @param {HTMLFormElement} form The form element.
	 *
	 * @returns {Promise<void>}
	 */
	const execute = async ( form ) => {
		// If form is not found, don't execute reCAPTCHA.
		if ( ! form ) {
			return;
		}

		// If configured to use checkboxes, don't execute v3 reCAPTCHA.
		if ( strings?.key_type === 'CHECKBOX' ) {
			return;
		}

		// Execute standard or enterprise reCAPTCHA depending on the connection type.
		if ( strings.connection_type === 'enterprise' ) {
			await executeEnterpriseRecaptcha( form );
		} else {
			await executeRecaptcha( form );
		}
	}

	/**
	 * @function executeRecaptcha
	 * @description Execute standard reCAPTCHA, setting the token to the hidden input field.
	 *
	 * @since 2.2.0
	 *
	 * @param {HTMLFormElement} form The form element.
	 *
	 * @returns {Promise<void>}
	 */
	const executeRecaptcha = async ( form ) => {
		const dataInput = form.querySelector( '.ginput_recaptchav3 .gfield_recaptcha_response' );

		// If reCAPTCHA fields can't be found, or recaptcha response is already set, don't execute reCAPTCHA.
		if ( ! dataInput || dataInput.value.length ) {
			return;
		}

		// Execute reCAPTCHA and set the token to the hidden input field.
		const token = await grecaptcha.execute( strings.site_key, { action: 'submit' } );
		if ( token.length && typeof token === 'string' ) {
			dataInput.value = token;
		}
	};

	/**
	 * @function executeEnterpriseRecaptcha
	 * @description Execute enterprise reCAPTCHA, setting the token to the hidden input field.
	 *
	 * @since 2.2.0
	 *
	 * @param {HTMLFormElement} form The form element.
	 *
	 * @returns {Promise<void>}
	 */
	const executeEnterpriseRecaptcha = async ( form ) => {

		const dataInput = form.querySelector( '.ginput_recaptchav3 .gfield_recaptcha_response' );

		// If reCAPTCHA fields can't be found, or recaptcha response is already set, don't execute reCAPTCHA.
		if ( ! dataInput || dataInput.value.length ) {
			return;
		}

		try {

			// Execute reCAPTCHA and set the token to the hidden input field.
			const token = await grecaptcha.enterprise.execute( strings.site_key, { action: 'submit' } );

			if ( token.length && typeof token === 'string' ) {
				dataInput.value = token;
			}
		} catch ( error ) {
			return;
		}
	};

	maybeDisableBadge = () => {
		if ( strings.connection_type === 'enterprise' ) {
			grecaptcha.enterprise.ready( function () {
				hideBadge();
			} );
		} else {
			grecaptcha.ready( function () {
				hideBadge();
			} );
		}
	}

	hideBadge = () => {
		if ( strings.disable_badge ) {
			var badge = document.querySelector( '.grecaptcha-badge' );
			if ( badge ) {
				badge.style.visibility = 'hidden';
			}
		}
	}

	const renderCheckboxes = ( formId = 0 ) => {
		const prefix = formId ? `#gform_${ formId }` : '.gform_wrapper';
		const containers = document.querySelectorAll( `${ prefix } .ginput_container_recaptcha_checkbox .g-recaptcha` );

		if ( ! containers ) {
			return;
		}

		containers.forEach( renderCheckbox );
	}

	const renderCheckbox = ( container, isLogicInit = false ) => {
		if ( ! grecaptcha?.enterprise?.render || ! container || container.dataset.initialized === 'true' || container.dataset.widgetid || ( ! isLogicInit && isContainerHiddenByParent( container ) ) ) {
			return;
		}

		// If the iframe is present on the container, something else has already rendered it.
		if ( container.querySelector( 'iframe' ) ) {
			container.dataset.initialized = 'true';
			return;
		}

		const widgetId = grecaptcha.enterprise.render( container );
		if ( ! Number.isInteger( widgetId ) ) {
			return;
		}

		container.dataset.initialized = 'true';
		container.dataset.widgetid = widgetId;
	}

	const isContainerHiddenByParent = ( container ) => {
		// Walk up the DOM from the container to the document root.
		let node = container.parentElement;
		while ( node ) {
			try {
				const style = getComputedStyle( node );
				if ( style?.display === 'none' ) {
					return true;
				}
			} catch ( e ) {
				// Some environments may throw for detached nodes; ignore and continue.
			}
			node = node.parentElement;
		}
		return false;
	};

	window.gform = gform;
	window.gform.recaptchaV3 = { execute };

	// Google requires a simple global function name for the onload callback. It looks like they call using array syntax: i.e. window['gravityformsrecaptchaRenderCheckboxes']();
	window.gravityformsrecaptchaRenderCheckboxes = renderCheckboxes;

	if ( strings?.key_type === 'CHECKBOX' ) {
		initCheckbox();
	} else {
		initScore();
	}

} )( window.gform || {}, window.grecaptcha || {}, gforms_recaptcha_recaptcha_strings );
